module.exports = __webpack_public_path__ + "media/images/ln/num_0-a29cb9fcd24025e252018418313fa60c.png";